const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const assetUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

let cache = { key: null, brand: null, img: null };

const loadImage = (src) => new Promise((resolve, reject) => {
  const i = new Image();
  i.crossOrigin = "anonymous";
  i.onload = () => resolve(i);
  i.onerror = reject;
  i.src = src;
});

export async function preloadPdfBrand(brand) {
  const key = JSON.stringify(brand || null);
  if (cache.key === key) return;
  cache = { key, brand, img: null };
  if (!brand?.logo_url) return;
  try {
    const img = await loadImage(assetUrl(brand.logo_url));
    const ratio = img.naturalWidth && img.naturalHeight ? img.naturalWidth / img.naturalHeight : 1;
    const c = document.createElement("canvas");
    c.height = 128;
    c.width = Math.round(128 * ratio);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    if (cache.key === key) cache.img = { data: c.toDataURL("image/png"), ratio };
  } catch (e) {
    console.warn("Brand logo preload failed", e);
  }
}

// Draws "Company · Division" (and logo) on the right side of a 56pt navy PDF header bar.
export function drawPdfBrand(doc, pageW, marginX, rightText = "") {
  const b = cache.brand;
  if (!b?.name) return;
  const label = [b.name, b.division].filter(Boolean).join(" · ");
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  doc.text(label, pageW - marginX, 46, { align: "right" });
  if (!cache.img) return;
  const h = 30;
  const w = Math.min(90, h * cache.img.ratio);
  const textW = Math.max(doc.getTextWidth(label), doc.getTextWidth(rightText));
  doc.addImage(cache.img.data, "PNG", pageW - marginX - textW - w - 12, 13, w, h);
}
